/*
 * @Author: wsx
 * @Date: 2022-01-15 16:39:06
 * @LastEditTime: 2022-03-05 11:13:02
 * @LastEditors: Please set LastEditors
 * @Description:
 */
export default [{
    path: "peerAnalysis",
    name: "peerAnalysis",
    component: () =>
      import ("@/views/smartApplication/peerAnalysis/index.vue"),
    meta: {
      title: "同行分析"
    }
  },
  {
    path: "threeSolidQuery",
    name: "threeSolidQuery",
    component: () =>
      import ("@/views/smartApplication/threeSolidQuery/index.vue"),
    meta: {
      title: "一标三实+N查询"
    }
  },
  {
    path: "spaceTimeCollision",
    name: "spaceTimeCollision",
    component: () =>
      import ("@/views/smartApplication/spaceTimeCollision/index.vue"),
    meta: {
      title: "时空碰撞"
    }
  },
  {
    path: "carSearch",
    name: "carSearch",
    component: () =>
      import ("@/views/smartApplication/carSearch/index.vue"),
    meta: {
      title: "车辆检索"
    }
  },
  {
    path: "personSearch",
    name: "personSearch",
    component: () =>
      import ("@/views/smartApplication/personSearch/index.vue"),
    meta: {
      title: "人员检索"
    }
  },
  {
    path: "identityCheck",
    name: "identityCheck",
    component: () =>
      import ("@/views/smartApplication/identityCheck.vue"),
    meta: {
      title: "身份稽查"
    }
  },
  {
    path: "faceContrast",
    name: "faceContrast",
    component: () =>
      import ("@/views/smartApplication/faceContrast.vue"),
    meta: {
      title: "人脸对比"
    }
  },
  {
    path: "videoAnalysis",
    name: "videoAnalysis",
    component: () =>
      import ("@/views/smartApplication/videoAnalysis/index.vue"),
    meta: {
      title: "视频解析"
    }
  },
  {
    path: "trackQuery",
    name: "trackQuery",
    component: () =>
      import ("@/views/smartApplication/trackQuery/index.vue"),
    meta: {
      title: "轨迹查询"
    }
  },
  {
    path: "electronicFence",
    name: "electronicFence",
    component: () =>
      import ("@/views/smartApplication/electronicFence.vue"),
    meta: {
      title: "电子围栏"
    }
  },
  {
    path: "faceRecord",
    name: "faceRecord",
    component: () =>
      import ("@/views/communityAccessManagement/passingRecord.vue"),
    meta: {
      title: "人行记录"
    }
  },
  {
    path: "carRecord",
    name: "carRecord",
    component: () =>
      import ("@/views/communityAccessManagement/carPassingRecord.vue"),
    meta: {
      title: "车行记录"
    }
  }
];